<div class="multi-date-field">
  <mat-form-field class="abcdj-mat-form-field" appearance="fill" floatLabel="always">
    <mat-label>{{label}}</mat-label>
    <mat-chip-grid #chipGrid [formControl]="control" >
      <mat-chip-row *ngFor="let date of control.value" (removed)="removeDate(date)">
        {{date}}
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    </mat-chip-grid>
    <input [placeholder]="placeholder"
            [matChipInputFor]="chipGrid"
            (matChipInputTokenEnd)="onChipChange($event)"
            [matDatepicker]="picker"
            (dateChange)="onDateChange($event)"
            [class.hiddenInput]="!inputVisible"
            />
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
</div>

